import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import HomeHero from './HomeHero';
import './Home.css';

const WHY_JOIN = [
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b344_icon-01.svg', title: 'Impactful Work', text: 'We empower you with real, meaningful responsibilities from day one, enabling you to bring your ideas to life and drive measurable change in everything you do.' },
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b345_icon-02.svg', title: 'People-First', text: 'We cultivate a supportive, growth-oriented culture that values open communication, long-term development, and strong professional relationships.' },
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b341_icon-04.svg', title: 'Career Mobility', text: "Your role doesn't define your future—your curiosity does. We actively support internal mobility, allowing you to shape your own career path across teams and disciplines." },
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b342_icon-03.svg', title: 'Inclusive Culture', text: 'Our strength lies in diverse perspectives. We are committed to creating an inclusive workplace where everyone feels welcome, respected, and able to thrive.' },
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b340_icon-06.svg', title: 'Ongoing Learning', text: 'We invest heavily in your continuous development, offering resources, mentoring, and structured planning to help you succeed today and grow for tomorrow.' },
  { icon: 'https://cdn.prod.website-files.com/68234acd8fb1ab421a72b174/68234ace8fb1ab421a72b343_icon-05.svg', title: 'Creative Freedom', text: 'We promote bold thinking and innovation, encouraging every team member to challenge convention, take initiative, and bring fresh ideas to the table.' },
];

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function Home() {
  const [whyRef, whyIn] = useInView(0.1);

  return (
    <main className="home">
      <HomeHero />

      {/* WE BUILD BRANDS */}
      <section className="build-brands">
        {/* Body */}
        <div className="build-brands__body intro-content-grid">
          {/* Instagram left */}
          
            <a href="https://www.instagram.com/renartglobal"
            target="_blank"
            rel="noreferrer"
            className="build-brands__social-btn build-brands__social-btn--left"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="2" width="20" height="20" rx="5"/>
              <circle cx="12" cy="12" r="4"/>
              <circle cx="17.5" cy="6.5" r="0.5" fill="white" stroke="none"/>
            </svg>
          </a>

          {/* Center */}
          <div className="build-brands__content">
            <h2 className="build-brands__heading">We Build Brands.</h2>
            <div className="spacer-large"></div>
            <p className="build-brands__text">
              We build and scale customer-centric unique d2c brands that engineer a
              responsible, end-to-end tailored shopping experience.
            </p>
            <div className="spacer-large"></div>
            <Link to="/about" className="btn-primary">
              <span>About Us</span>
              <div className="btn-primary__circle">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"/>
                </svg>
              </div>
            </Link>

            <div className="build-brands__mobile-actions">
              <a href="https://www.instagram.com/renartglobal"
                target="_blank"
                rel="noreferrer"
                className="build-brands__social-btn build-brands__mobile-social-btn"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2" y="2" width="20" height="20" rx="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="0.5" fill="white" stroke="none"/>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/renartglobal/"
                target="_blank"
                rel="noreferrer"
                className="build-brands__social-btn build-brands__mobile-social-btn"
                aria-label="LinkedIn"
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
              <Link to="/about" className="btn-primary build-brands__mobile-btn">
                <span>About Us</span>
                <div className="btn-primary__circle">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16.0037 9.41421L7.39712 18.0208L5.98291 16.6066L14.5895 8H7.00373V6H18.0037V17H16.0037V9.41421Z"/>
                  </svg>
                </div>
              </Link>
            </div>
          </div>

          {/* LinkedIn right */}
          
            <a href="https://www.linkedin.com/company/renartglobal/"
            target="_blank"
            rel="noreferrer"
            className="build-brands__social-btn build-brands__social-btn--right"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect x="2" y="9" width="4" height="12"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </a>
        </div>
      </section>

      {/* WHY JOIN US */}
      <section className="why-join" ref={whyRef}>
        <div className="container-large">
          <div className="why-join__header">
            <h2 className="section-title">Why Join Us</h2>
            <div className="spacer-small" style={{ paddingTop: '2rem' }}></div>
            <div className="why-join__intro-wrap">
              <p className="why-join__intro">
                We are a team of curious minds with diverse backgrounds, who have come together
                with a passion to collaborate in creating innovative, dynamic and responsible
                brands that cater to the evolving needs of our global customers
              </p>
            </div>
          </div>

          <div className={`why-join__grid ${whyIn ? 'animate-in' : ''}`}>
            {/* Row 1 — slides in from right */}
            <div className="why-row why-row--top">
              {WHY_JOIN.slice(0, 3).map((item, i) => (
                <div className="service-item" key={item.title} style={{ animationDelay: `${i * 0.1}s` }}>
                  <div className="service-inner">
                    <div className="service-content">
                      <img src={item.icon} alt="" className="service-icon" />
                      <div className="service-heading">{item.title}</div>
                    </div>
                    <p className="service-text">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Row 2 — slides in from left */}
            <div className="why-row why-row--bottom">
              {WHY_JOIN.slice(3).map((item, i) => (
                <div className="service-item" key={item.title} style={{ animationDelay: `${(i + 3) * 0.1}s` }}>
                  <div className="service-inner">
                    <div className="service-content">
                      <img src={item.icon} alt="" className="service-icon" />
                      <div className="service-heading">{item.title}</div>
                    </div>
                    <p className="service-text">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}